<template src="./OrkStock.html"></template>
<style lang="scss" src="./OrkStock.scss"></style>

<script>
import {
  SfButton,
} from '@storefront-ui/vue';
import ProductOptions from "@/utils/product_options";

export default {
  name: 'OrkStock',
  components: {
    SfButton
  },
  props: {
    stockMessage:{type:Object},
    OfferId: {type: String},
    quantity: {type: Number},
    showStockAlert: {type: Boolean, default: true}
  },
  data() {
    return {
      minimalQuantity: ProductOptions.getProductOptions.minimalQuantity
    }
  },
  methods: {
    toggleStockAlertModal() {
      this.$router.push('/contact')
      //this.$store.dispatch('toggleStockAlertModal',{open:true, product: this.OfferId })
    }
  }
};
</script>